import config from '@configFile';

// export const getDealPageSEOData = (
//   image: string,
//   title: string,
//   imageWidth: number,
//   imageHeight: number,
//   description = config.DESCRIPTION
// ) => {
//   return {
//     '@context': 'http://www.schema.org',
//     '@type': 'BlogPosting',
//     name: config.app.title,
//     headline: title,
//     url: config.SITE_URL,
//     sameAs: [config.FACEBOOK_LINK],
//     logo: config.LOGO,
//     image,
//     imageWidth,
//     imageHeight,
//     description,
//     datePublished: new Date().toISOString(),
//     dateModified: new Date().toISOString()
//   };
// };

export const getSEOMeta = ({
  image,
  slug,
  description,
  title
}: {
  image: string;
  slug: string;
  description: string;
  title: string;
}) => {
  return [
    { property: 'og:type', content: 'article' },
    {
      property: 'og:url',
      content: `${config.SITE_URL}/p/${slug}`
    },
    { property: 'og:site_name', content: 'Jungle Deals' },
    {
      property: 'og:description',
      content: description
    },
    {
      property: 'description',
      name: 'description',
      content: description
    },
    {
      property: 'og:image',
      content: image
    },
    {
      property: 'og:title',
      content: title
    },
    { property: 'og:width', content: '800' },
    { property: 'og:height', content: '275' },
    { property: 'og:alt', content: title },
    { property: 'og:locale', content: 'en_US' },
    {
      property: 'article:published_time',
      content: new Date(new Date().setHours(4, 0, 0)).toISOString()
    },
    {
      property: 'article:modified_time',
      content: new Date(new Date().setHours(4, 0, 0)).toISOString()
    },
    { property: 'twitter:image', content: image },
    { property: 'twitter:title', content: title },
    { property: 'twitter:description', content: description },
    { property: 'twitter:card', content: image },
    { property: 'twitter:site', content: config.SITE_URL }
  ];
};

export const getDealCtString = (dealCount: number) => {
  return dealCount > 0 ? `${dealCount} Deal${dealCount === 1 ? '' : 's'}` : '';
};

export const getDealCountString = (
  dealCount: number,
  category: string | null
) => {
  return dealCount > 0
    ? `${dealCount} ${category || ''} Deal${dealCount === 1 ? '' : 's'}`
    : '';
};

export const getDealCountStringNoNum = (
  dealCount: number,
  category: string | null
) => {
  return `${category || ''} Deal${dealCount === 1 ? '' : 's'}`;
};

export const getDealStr = (dealCount: number, category: string | null) => {
  return dealCount > 0
    ? `${category || ''} Deal${dealCount === 1 ? '' : 's'}`
    : '';
};
